import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { AuthService, CacheService } from '../../auth.service';
import { RouterLink } from '@angular/router';
import { BucketPipe } from '../../bucket.pipe';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { ImageFallbackDirective } from '../../image-fallback.directive';
import { IOfferCard, splitBitwise, weekdaysAsBitwise } from '../../types';
import { OfferLoyaltyCardComponent } from '../offer-loyalty-card/offer-loyalty-card.component';

export interface IOfferRestriction{
    days: number;
    holidays: boolean;
}

@Component({
  selector: 'offer-card',
  standalone: true,
  imports: [RouterLink, BucketPipe, MatIcon, MatIconButton, ImageFallbackDirective, OfferLoyaltyCardComponent],
  templateUrl: './offer-card.component.html',
  styleUrl: './offer-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.--offer-fill-color]': 'planColors()?.background || "#0075ff"',
    '[style.--offer-text-color]': 'planColors()?.foreground || "#ffffff"',
  }
})
export class OfferCardComponent {

  cache = inject(CacheService);
  auth = inject(AuthService);

  offer = input.required<IOfferCard>();

  showImage = input<boolean>(false);
  replaceCta = input<boolean>(false);
  replaceBody = input<boolean>(false);
  replaceFooter = input<boolean>(false);

  weekdaysAsBitwise = weekdaysAsBitwise;

  locked = computed(() => !this.auth.userPlans().includes(this.offer().plan));

  planColors = computed(() => this.cache.registeredPlans().find(plan => this.offer().plan == plan.identifier)?.color_settings);

  usage = computed(() => {
    const { userinterval, userlimit } = this.offer() || { userlimit: 1, userinterval: 'user' };

    if(!userlimit) return 'UNLIMITED USES';

    let text = '';

    if(userlimit == 1){
      text += 'USE ONCE';
    } else {
      text += `USE ${userlimit} TIMES`;
    }

    if(!userinterval || userinterval != 'user'){
      text += ` PER ${userinterval.toUpperCase()}`;
    }

    return text;
  });

  weekdays = computed(() => splitBitwise(this.offer()?.restrictions?.days || 0));

  people = computed(() => {
    const { people_max, people_min } = this.offer();

    if(people_min && people_max){
      return `${people_min}-${people_max}`;
    } else if(people_min){
      return `${people_min}+`;
    } else if(people_max){
      return `1-${people_max}`;
    }

    return '';
  });

}
